import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../../assets/css/feedback.css";
import { useDashboardContext } from "../../context/customhook/dashboardHook";
import { SubmitFeedback } from "../../context/provider/submitFeedback";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import "../../assets/css/style.css";

export default function Feedback() {
  const { t } = useTranslation();
  const { setDashboardStates } = useDashboardContext();
  const [mobile, setMobile] = useState();
  const [isChecked, setIsChecked] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");

  //Rating Click Event
  const feedbackOnClick = () => {
    setDashboardStates((previousState) => {
      return {
        ...previousState,
        isSubmitClicked: true,
        mobileNumber: mobile,
        concent: isChecked,
        feedbackRemark: feedbackText,
      };
    });
  };

  return (
    <SubmitFeedback>
      <div className="feedback-container">
        <label className="feedback-title">{t("moreFeedback")}</label>
        <label className="feedback-details">{t("moreFeedbackDetails")}</label>
        <div className="feedback-header">
          <label className="label-input-title">{t("mobile")}</label>
          <PhoneInput
            placeholder={t("enterMobile")}
            value={mobile}
            country="ae"
            className={"input-phone-number"}
            onChange={setMobile}
          />
        </div>
        <div className="feedback-header">
          <label className="label-input-title">{t("feedback")}</label>
          <textarea
            className="feedback-input"
            id="subject"
            name="subject"
            maxLength={200}
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }}
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            autoComplete="off"
            placeholder={t("enterFeedback")}
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
          />
          <label className="inline-block py-3">
            <input
              type="checkbox"
              className="h-4 w-4"
              checked={isChecked}
              onChange={() => setIsChecked((prev) => !prev)}
            />
            <span className="px-2 align-super text-[#242428]">
              {t("concent")}
            </span>
          </label>
          <button
            onClick={() => feedbackOnClick()}
            id="submit-button"
            className="submit-button"
          >
            {t("submit")}
          </button>
        </div>
      </div>
    </SubmitFeedback>
  );
}
